import React, { useRef, useEffect } from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@mui/styles';

import PropTypes from 'prop-types';

import {
    select as D3select,
    range as D3range,
} from 'd3';

import D3Radar from '../../d3/D3Radar';
import { skyBlue, orange } from '../../data/colors';

const useStyles = makeStyles(theme => ({
    root: {
        '& .polygon': {
        },
        '& .axis-label': {
            fontFamily: 'Roboto',
            fontSize: 11,
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            fill: theme.palette.text.primary,
            cursor: 'pointer',
        },
        '& .layers-label': {
            fill: theme.palette.primary.main,
            fontSize: 11,
            letterSpacing: '0.2em',
            pointerEvents: 'none',
        },
        '& .values-label': {
            fill: theme.palette.text.primary,
            fontSize: 11,
            letterSpacing: '0.2em',
            pointerEvents: 'none',
        },
    },
}));

const groups = [
    { key: 'strings', title: 'Strings' },
    { key: 'data_dir', title: 'Data Direction' },
    { key: 'byte_hist', title: 'Byte Histogram' },
    { key: 'file_info', title: 'File Info' },
    { key: 'header_info', title: 'Header Info' },
    { key: 'entropy_hist', title: 'Entropy Histogram' },
    { key: 'exports_info', title: 'Exports Info' },
    { key: 'imports_info', title: 'Imports Info' },
    { key: 'section_info', title: 'Section Info' },
];

const bkgColors = [skyBlue[500], skyBlue[300], skyBlue[250], skyBlue[150], skyBlue[75]];
const fgdColor = orange[300];
const MARGIN = 6;
const MINSIZE = 250;
const PADDING = 70;
const LABELS = 230;

const background = D3range(10, 0, -2).map((d, i) => ({
    group: `background_${d}`,
    color: bkgColors[i],
    label: d === 10,
    axes: groups.map(g => ({
        axis: g.title,
        value: d,
    })),
    range: { min: d - 2, max: d, },
}));

const Radar = (props) => {
    const d3Container = useRef(null);
    const classes = useStyles();
    const theme = useTheme();

    useEffect(() => {
        if (d3Container.current) {
            const node = d3Container.current;

            const range = Object.values(props.data.explain).reduce((a, c) => ({
                min: a.min < c * 10 ? a.min : c * 10,
                max: a.max > c * 10 ? a.max : c * 10,
            }), {});
            // data layer
            const values = {
                group: 'data',
                color: fgdColor,
                points: true,
                axes: groups.map(g => ({
                    group: g.title,
                    value: +props.data.explain[g.key] * 10,
                })),
                range,
            };

            const data = [{
                id: 'once',
                data: [...background, values],
            }];

            const width = Math.max(props.width, MINSIZE);
            const height = Math.max(props.height, MINSIZE);

            D3select(node).selectAll('svg').data(data).join('svg')
                // .style('display', 'block')
                // .style('margin-left', MARGIN)
                .style('margin', MARGIN)
                .attr('width', width - 2 * MARGIN)
                .attr('height', height - 2 * MARGIN)
                .call(D3Radar()
                    .theme(theme)
                    .padding(PADDING)
                    .size(Math.min(width - LABELS, height)));
        }
    }, [props.width, props.height, theme, props.data]);

    return (
        <div className={clsx(props.className, classes.root)}>
            <div ref={d3Container}></div>
        </div>
    );
};

Radar.propTypes = {
    height: PropTypes.number,
    width: PropTypes.number,
    data: PropTypes.object,
    className: PropTypes.string,
};

export default Radar;
